import { List } from "immutable";
import { SelectableInput } from "../../dynamic-forms/inputs/selectable-input.model";

export class ArrayHelper {
  static isAvailable(value: any[] | List<any>): boolean {
    if (!Array.isArray(value) && !List.isList(value)) {
      return false;
    }

    const list = List(value);
    return list.size > 0;
  }

  static throwIsAvailableError(value: any[], propertyName: string): void {
    if (!this.isAvailable(value)) {
      throw new Error(`The property '${propertyName}' cannot be null or empty.`);
    }
  }

  static toArray(value: any[] | List<any>): any[] {
    return List.isList(value) ? (value as List<any>).toArray() : (value as any[]);
  }

  static addItemToSelect(data: SelectableInput[], text: string, value: string | number): SelectableInput[] {
    data.unshift(new SelectableInput({
      text, value,
    }));

    return data;
  }

  static clean(value: any[], defaultValue = []): any[] {
    return this.isAvailable(value) ? value : defaultValue;
  }

  static chunkArray(value: any[], chunkSize: number): any[] {
    if (!this.isAvailable(value)) {
      return [];
    }

    const chunked = [];
    let index = 0;
    while (index < value.length) {
      chunked.push(value.slice(index, chunkSize + index));
      index += chunkSize;
    }
    return chunked;
  }
}
